// -------------------- Variant change listener --------------------
document.addEventListener('variant:changed', function(event) {
    const variant = event.detail.variant; 
    console.log("variant=="+variant.id);

    const elmts = document.querySelector(`[data-variant-id="${variant.id}"]`);
    const elmtVal = elmts ? elmts.dataset.variantValue : null;

    const PerItem = document.querySelector('.product-variant-selected');
    if (PerItem && elmtVal !== null) {
        PerItem.innerHTML = " Per item: " + elmtVal;
    } else {
        console.log('⛔️ class does NOT exist on page or value missing');
    }
});


// -------------------- Exit Intent Popup --------------------
let timerStarted = false;
let popupClosed = localStorage.getItem('popupClosed') === 'true';

document.addEventListener('mouseleave', function(e) {
    if (!timerStarted && !popupClosed && e.clientY < 10) {
        timerStarted = true;
        setTimeout(function () {
            const overlay = document.getElementById('exitPopupOverlay');
            const popup = document.getElementById('exitPopup');
            if (!popupClosed && overlay && popup) {
                overlay.style.display = 'block';
                popup.style.display = 'block';
            }
        }, 10000);
    }
});

const closeBtn = document.querySelector('.close-popup');
if (closeBtn) {
    closeBtn.addEventListener('click', function() {
        const overlay = document.getElementById('exitPopupOverlay');
        const popup = document.getElementById('exitPopup');
        if (overlay) overlay.style.display = 'none';
        if (popup) popup.style.display = 'none';
        popupClosed = true;
        localStorage.setItem('popupClosed', 'true');
    });
}


// -------------------- AI ChatBot Functions --------------------
document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('chatSearchForm');
    const input = document.getElementById('chatInput');
    const overlay = document.getElementById('searchOverlay');
    const responseContainer = document.getElementById('chatResponses');
    const followUpForm = document.getElementById('chatFollowUpForm');
    const followUpInput = document.getElementById('chatFollowUpInput');

    if (!sessionStorage.getItem('chat_user_id')) {
        const randomId = 'user_' + Math.random().toString(36).substring(2, 12);
        sessionStorage.setItem('chat_user_id', randomId);
    }

    const userId = sessionStorage.getItem('chat_user_id');

    const handlePromptSubmit = (query) => {
        if (!query || !overlay || !responseContainer) return;

        overlay.style.display = 'block';

        const loadingDiv = document.createElement('div');
        loadingDiv.className = 'loadingBox';
        const loadingTemplate = document.getElementById('ai-loading-template');
        if (loadingTemplate) loadingDiv.innerHTML = loadingTemplate.innerHTML;
        responseContainer.appendChild(loadingDiv);

        fetch('https://api.allcottonandlinen.com/chat', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ message: query, user_id: userId })
        })
        .then(response => response.json())
        .then(data => {
            loadingDiv.remove();
            const responses = data;
            const resBox = document.createElement('div');
            resBox.classList.add('chat-response-box');
            resBox.style = 'background: #fff; padding-bottom: 1rem;';

            const iconHTML = `
            <span style="position: relative; width: 20px; height: 20px; display: inline-block; transform: translateY(5px);">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" width="19" height="19" fill="#051E38">
                <path d="M32.12 4.58c.86-2.08 3.9-2.08 4.76 0l5.72 13.81a3 3 0 0 0 1.63 1.63l13.81 5.72c2.08.86 2.08 3.9 0 4.76l-13.81 5.72a3 3 0 0 0-1.63 1.63l-5.72 13.81c-.86 2.08-3.9 2.08-4.76 0l-5.72-13.81a3 3 0 0 0-1.63-1.63L10.96 30.5c-2.08-.86-2.08-3.9 0-4.76l13.81-5.72a3 3 0 0 0 1.63-1.63l5.72-13.81z" />
              </svg>
            </span>`;

            let html = `<p style="font-weight: bold; margin-bottom: 0.3rem;">${iconHTML} ${query}</p>`;

            if (responses.intent_response) {
                html += `<p style="margin-top: 0.5rem; font-size: 14px;">${responses.intent_response}</p>`;
            } else if (responses.product_result && responses.product_result.products) {
                html += `<div style="display: flex; gap: 16px; flex-wrap: wrap;">`;
                responses.product_result.products.forEach((item) => {
                    html += `
                    <div style="width: 160px; background: #fff; border-radius: 10px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); overflow: hidden; text-align: center; cursor: pointer; margin-bottom: 20px;">
                        <div style="width: 100%; height: 150px; overflow: hidden; margin-top: 10px;">
                            <img loading="lazy" decoding="async" src="${item.image}" onclick="openImageModal('${item.image}', '${item.link}')" style="width: 100%; height: 100%; object-fit: cover; display: block;" />
                        </div>
                        <div style="padding: 10px 8px; height: 120px; display: flex; flex-direction: column; justify-content: space-between;">
                            <p style="margin: 0 0 8px; font-size: 13px; font-weight: 600; color: #333; line-height: 1.3; flex-grow: 1;">${item.title}</p>
                            <a href="${item.link}" target="_blank" style="display: block; width: 100%; font-size: 12px; color: white; text-decoration: none; background-color: #051E38; padding: 8px; border-radius: 4px; text-align: center;">View Product</a>
                        </div>
                    </div>`;
                });
                html += `</div>`;
            }

            resBox.innerHTML = html;
            responseContainer.appendChild(resBox);
            overlay.scrollTo({ top: overlay.scrollHeight, behavior: 'smooth' });
        })
        .catch(err => {
            loadingDiv.remove();
            alert('Something went wrong. Please try again.');
        });
    };

    if (form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            const query = input.value.trim();
            input.value = '';
            handlePromptSubmit(query);
        });
    }

    if (followUpForm) {
        followUpForm.addEventListener('submit', function(e) {
            e.preventDefault();
            const query = followUpInput.value.trim();
            followUpInput.value = '';
            handlePromptSubmit(query);
        });
    }

    document.querySelectorAll('.prompt-button').forEach((btn) => {
        btn.addEventListener('click', () => {
            const query = btn.getAttribute('data-prompt');
            handlePromptSubmit(query);
        });
    });
});


// -------------------- Image Modal --------------------
let currentProductLink = '#';

function openImageModal(src, link) {
    const modal = document.getElementById('imageModal');
    const img = document.getElementById('modalImage');
    const modalLink = document.getElementById('modalImageLink');
    const copyMsg = document.getElementById('copySuccessMsg');

    if (modal && img && modalLink && copyMsg) {
        img.src = src;
        modalLink.href = link || src;
        currentProductLink = link || src;

        copyMsg.style.display = 'none';
        modal.style.display = 'flex';
    }
}

function closeImageModal() {
    const modal = document.getElementById('imageModal');
    if (modal) modal.style.display = 'none';
}

function shareProductLink() {
    if (!navigator.clipboard) return alert('Clipboard not supported');

    navigator.clipboard.writeText(currentProductLink).then(() => {
        const msg = document.getElementById('copySuccessMsg');
        if (msg) {
            msg.style.display = 'block';
            setTimeout(() => { msg.style.display = 'none'; }, 2000);
        }
    });
}